import React, { createContext, useContext, ReactNode } from 'react';
import type { Meeting } from '../types/meetings';

interface DiaryManagementContextType {
  onViewMeetingDetails: (meeting: Meeting, allMeetings: Meeting[]) => void;
}

const DiaryManagementContext = createContext<DiaryManagementContextType | undefined>(undefined);

export const useDiaryManagementContext = () => {
  const context = useContext(DiaryManagementContext);
  if (!context) {
    throw new Error('useDiaryManagementContext must be used within DiaryManagementProvider');
  }
  return context;
};

interface DiaryManagementProviderProps {
  children: ReactNode;
  onViewMeetingDetails: (meeting: Meeting, allMeetings: Meeting[]) => void;
}

export const DiaryManagementProvider: React.FC<DiaryManagementProviderProps> = ({
  children,
  onViewMeetingDetails,
}) => {
  return (
    <DiaryManagementContext.Provider value={{ onViewMeetingDetails }}>
      {children}
    </DiaryManagementContext.Provider>
  );
};
